import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {TableControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl.Options";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {HTMLTableCreator} from "shared/utilities/HTMLTableCreator/HTMLTableCreator";
import {TableItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableItem";

import './Styles.css';
import {BasicContext} from "shared/utilities/Context/BasicContext";


declare let rednaoPDFInvoiceParams:any;
export class TableControl extends PDFControlBase{

    public TableItem:TableItem;
    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this),
                new GroupProperties('Label Styles').AddProperties([

                ])

            ];
    }
    public AllowedResizeDirection:AllowedResizeDirection="horizontal";
    public Options:TableControlOptions;
    private properties:GroupProperties[];



    public InternalInitialize() {
        this.TableItem=new TableItem(this);

    }


    DeSelect() {
        super.DeSelect();
        this.TableItem.SelectColumn(null);
        console.log('deselect');
    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new TableControlOptions().Merge({
                Styles:{Left:'2%',Width:'96%'},
                TableItem:{
                    Rows:[
                        {Columns:[{Width:50},{Width:50}]},
                        {Columns:[{Width:50},{Width:50}]}
                    ]
                }

            }));
        });
    }


    public ShowContext(e: any) {

        let items = [
            {
                title: 'Remove Table', icon: 'contexticon deleteItem fa fa-times', fn: () => {
                    this.Remove()
                }
            },
            {
                title: 'Duplicate Table', icon: 'contexticon deleteItem fa fa-files-o', fn: () => {
                    this.Duplicate()
                }
            },
            {},
            this.TableItem.SelectedColumns.length>0&&this.TableItem.SelectedColumns[0].Fields.length>0&&{
                title: 'Delete Field', url: rednaoVar.URL+'images/tableIcons/deletecell.svg', fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.SelectedColumns[0].DeleteFields();
                }
            },
            {
                title: 'Delete Row', url: rednaoVar.URL+'images/tableIcons/deleterow.svg', fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.DeleteRow(this.TableItem.SelectedColumns[0].RowItem);
                }
            },
            {
                title: 'Delete Column', url: rednaoVar.URL+'images/tableIcons/deletecolumn.svg', fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.DeleteColumn(this.TableItem.SelectedColumns[0]);
                }
            },
            {},
            {
                title: 'Add row above', url: rednaoVar.URL+'images/tableIcons/insertrowabove.svg',fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.CreateRow(this.TableItem.SelectedColumns[0].RowItem,"before");
                }
            },
            {
                title: 'Add row bellow', url: rednaoVar.URL+'images/tableIcons/insertrowbellow.svg',fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.CreateRow(this.TableItem.SelectedColumns[0].RowItem,"after");
                }
            },
            {},

            {
                title: 'Add column to the left',url: rednaoVar.URL+'images/tableIcons/insertcolumnbefore.svg', fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.CreateColumn(this.TableItem.SelectedColumns[0],'before');
                }
            },
            {
                title: 'Add column to the right',url: rednaoVar.URL+'images/tableIcons/insertcolumnafter.svg', fn: () => {
                    if(this.TableItem.SelectedColumns.length>0)
                        this.TableItem.CreateColumn(this.TableItem.SelectedColumns[0],'after');
                }
            }


        ];

        BasicContext.Show(items, e.originalEvent)

    }

    SetInitialStyles() {
        super.SetInitialStyles();
        this.StyleManager.ClearFieldStyles();
        this.StyleManager.AddStyleSet('.tablefield',{'width':'100%'});
        this.StyleManager.AddStyleSet('.tablefield > tbody > tr > td',{'border':'1px solid #dfdfdf'});

    }

    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:''};
    }

    protected InternalGenerateHtml($container: JQuery) {
        this.TableItem.Generate($container[0]);

    }

    public GetProperties(): GroupProperties[] {
        return [];
    }



}
